<template>
    <div class="vue timparty-cards-steps-carousel cards-steps-carousel">
      <div class="cards-steps-container">
        <div class="container p-0">
          <header class="text-center">
              <h3 class="header-title" v-if="component_data.title">{{ component_data.title }}</h3>
              <p class="header-summary" v-if="component_data.subtitle">{{ component_data.subtitle }}</p>
              <div class="header-content" v-if="component_data.description" v-html="component_data.description"></div>
          </header>
          <section class="cards-steps-slider">
            <div class="px-4 h-100"  v-for="(card,idx) in component_data.cards" v-bind:key="idx">
              <div :class="'card h-100 ' + (card.cardClass != undefined ? card.cardClass : '')">
                  <h2 v-if="!hideNumbers && !card.hideNumbers && !card.customNumber">{{ idx+1 }}</h2>
                  <h2 v-else-if="card.customNumber">{{ card.customNumber }}</h2>
                  <h3 class="card-title" v-if="card.title" v-html="card.title"></h3>
<!--                  <div class="card-content" v-if="card.compare_others.includes(user.type.toUpperCase()) && card.description_others" v-html="card.description_others"></div>-->
                  <div class="card-content" v-if="[].concat(card.compare_others).includes((user.type||'').toUpperCase())  && card.description_others" v-html="card.description_others"></div>
                  <div class="card-content" v-else-if="card.description" v-html="card.description"></div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
</template>

<script>

    /* eslint-disable */

    import TimPartyMixin from '../mixins/TimPartyMixin';
    import $ from 'jquery';

    export default {
      name: 'CardsStepsSlider',
      mixins: [ TimPartyMixin ],
      props: {
        hideNumbers: {
          type: Boolean,
          required: false,
          default: false,
        },
        customNumber: {
          type: Number,
          required: false,
          default: false,
        },
        data: {
          type: Object,
          required: true,
        }
      },
      data: function(){

        return {
          component_data: {},
        };
      },
      mounted: function(){

        var self = this;


        if(this.data)
          this.component_data = this.data;


        if( this.component_data.cards.length > 1){

            this.$nextTick( function(){

              var slides_to_show = self.component_data.cards.length < 4 ? self.component_data.cards.length : 4;

              $('.cards-steps-slider').slick({
                dots: false,
                infinite: false,
                arrows: false,
                slidesToShow: slides_to_show,
                slidesToScroll: 4,
                autoplay: false,
                responsive: [

                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2.1,
                            slidesToScroll: 1,
                            dots: false,
                        }
                    },
                    {
                        breakpoint: 520,
                        settings: {
                            slidesToShow: 1.1,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: false,
                        }
                    }
                ]
              });
            });
          }

      },

      methods: {

      },
      computed: {

      }
    }
  </script>


